import { L1ConfType } from '../types/liquidInstance';

export function getL1Conf(chain: string): L1ConfType {
  switch (chain) {
    case 'swellchain':
      return L1Conf;
    case 'taiko':
      return holeskyConf;
    case 'starknet':
      return L1Conf;
    case 'bitlayer':
      return holeskyConf;
    case 'hemi':
      return L1Conf;
    case 'morph':
      return holeskyConf;
    case 'tac':
      return L1Conf;
    case 'bsc':
      return holeskyConf;
    case 'arbitrum':
      return holeskyConf;
    case 'optimism':
      return holeskyConf;
    case 'monad':
      return holeskyConf;
    case 'soneium':
      return holeskyConf;
    default:
      return L1Conf;
  }
}
export const holeskyConf: L1ConfType = {
  L1Token: 'USDC',
  L1TokenDecimals: 6,
  L1TokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
  chain: 'holesky',
  chainId: 17000,
  multicall3Address: '0xcA11bde05977b3631167028862bE2a173976CA11'
};

export const sepoliaConf: L1ConfType = {
  L1Token: 'USDC',
  L1TokenDecimals: 6,
  L1TokenAddress: '0x02eA187D39f8F612c7A16Ba5D05B21bbEA28eF82',
  chain: 'sepolia',
  chainId: 11155111,
  multicall3Address: '0xcA11bde05977b3631167028862bE2a173976CA11'
};

export const L1Conf: L1ConfType = {
  L1Token: 'USDC',
  L1TokenDecimals: 6,
  L1TokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  chain: 'mainnet',
  chainId: 1,
  multicall3Address: '0xcA11bde05977b3631167028862bE2a173976CA11'
};

export const currentInstances = [
  {
    name: 'Swellchain',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-swell',
    L1WrappedTokenAddress: '0xCB35Be279968F6c53EBF73c8d9D5d7AAf4d34956',
    L1OFTAdapterAddress: '0x1939F8C45A7bAf32eBe309e6DA37de128ce4dD07',
    L2TokenName: 'rUSDC-swell',
    L2TokenAddress: '0x9ab96A4668456896d45c301Bc3A15Cee76AA7B8D',
    L2TokenIsOFT: true,
    L2ChainID: 1923,
    L2ChainEVM: true,
    BridgeUrl: 'https://superbridge.swellnetwork.io/',
    live: true,
    display: true
  },
  {
    name: 'Sonic',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-sonic',
    L1WrappedTokenAddress: '0xE6C6f1bEfe53826eF84e9C263DE398c31e8cf05c',
    L1OFTAdapterAddress: '0xa791cd8D3cF2a3911BF926B9a5FE9443B2d63ac7',
    L2TokenName: 'rUSDC-sonic',
    L2TokenAddress: '0x9ab96A4668456896d45c301Bc3A15Cee76AA7B8D',
    L2TokenIsOFT: true,
    L2ChainID: 146,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: true,
    display: false
  },
  {
    name: 'Hemi',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-hemi',
    L1WrappedTokenAddress: '0x4C4977EE52baa82437BC4C92343FFDE7EFEA904C',
    L1OFTAdapterAddress: '0x1608c1F28D07BCAAb1ED2D547b420578aF4Fd047',
    L2TokenName: 'rUSDC-hemi',
    L2TokenAddress: '0x9ab96A4668456896d45c301Bc3A15Cee76AA7B8D',
    L2TokenIsOFT: true,
    L2ChainID: 43111,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: true,
    display: false
  },
  {
    name: 'Starknet',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-stark',
    L1WrappedTokenAddress: '0x275bf5c13DE6a96aE1718bBb053AB1ADb006e867',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-stark',
    L2TokenAddress: '0x02019e47a0bc54ea6b4853c6123ffc8158ea3ae2af4166928b0de6e89f06de6c',
    L2TokenIsOFT: false,
    L2ChainID: -1,
    L2ChainEVM: false,
    BridgeUrl: 'https://starkgate.starknet.io/ethereum/bridge?mode=deposit',
    live: true,
    display: true
  },
  {
    name: 'Tac',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-tac',
    L1WrappedTokenAddress: '0x4Fb528c491EE4f2298044fb4C5b47C037E2A1528',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-tac',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 239,
    L2ChainEVM: true,
    BridgeUrl: 'https://tac.build/',
    live: true,
    display: true
  },
  {
    name: 'Bitlayer',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-bit',
    L1WrappedTokenAddress: '0x61F3e9C2B078f6245513a40035B5Ff0592896e41',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-bit',
    L2TokenAddress: '0x01c5814d7b2e7e38f10d38128c8e5e219fe610fc7a36ad86b78afb325dd2d9bd',
    L2TokenIsOFT: true,
    L2ChainID: 167000,
    L2ChainEVM: true,
    BridgeUrl: 'https://www.bitlayer.org/bridge',
    live: false,
    display: true
  },
  {
    name: 'Taiko',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-taiko',
    L1WrappedTokenAddress: '0x469938C81CA23A35ACb14439cC068808f1cBAD7E',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-taiko',
    L2TokenAddress: '0x6795c49F704a03583f766086f90194D72ccC8158',
    L2TokenIsOFT: true,
    L2ChainID: 167009,
    L2ChainEVM: true,
    BridgeUrl: 'https://bridge.hekla.taiko.xyz/',
    live: false,
    display: true
  },
  {
    name: 'Morph',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    L1WrappedTokenName: 'rUSDC-morph',
    L1WrappedTokenAddress: '0x1593EC75d7Fd91F0bB921825453BfA6032915115',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-morph',
    L2TokenAddress: '0x97D91024A97219fe10D154B00c26bAf1D49D955C',
    L2TokenIsOFT: true,
    L2ChainID: 167000,
    L2ChainEVM: true,
    BridgeUrl: 'https://bridge-holesky.morphl2.io/',
    live: false,
    display: true
  },
  {
    name: 'BSC',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
    L1WrappedTokenName: 'rUSDC-bsc',
    L1WrappedTokenAddress: '0xaD9B4d5E32e7384275953CE9405612404c379160',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-bsc',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 56,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: false,
    display: true
  },
  {
    name: 'Arbitrum',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
    L1WrappedTokenName: 'rUSDC-arb',
    L1WrappedTokenAddress: '0x1E47A831e3297Df1e6537Ed8DA75e7Dd287257AF',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-arb',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 42161,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: false,
    display: true
  },
  {
    name: 'Optimism',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
    L1WrappedTokenName: 'rUSDC-op',
    L1WrappedTokenAddress: '0x86EDEB2fc81Db743e62195d003E9FcB9e25426EB',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-op',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 10,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: false,
    display: true
  },
  {
    name: 'Monad',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
    L1WrappedTokenName: 'rUSDC-monad',
    L1WrappedTokenAddress: '0x5F3D1c2C85057DA94bc41fAA32925F3a69Ba02e4',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-monad',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 10,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: false,
    display: true
  },
  {
    name: 'Soneium',
    L1UnderlyingTokenName: 'USDC',
    L1UnderlyingTokenAddress: '0xe88a217b3C00eFf21e02B83991e0a1BAFeA084Ca',
    L1WrappedTokenName: 'rUSDC-soneium',
    L1WrappedTokenAddress: '0x9ED5131E321e3A6f304F5FDfe1c856CE674676e9',
    L1OFTAdapterAddress: '0x0000000000000000000000000000000000000000',
    L2TokenName: 'rUSDC-soneium',
    L2TokenAddress: '0x0000000000000000000000000000000000000000',
    L2TokenIsOFT: false,
    L2ChainID: 10,
    L2ChainEVM: true,
    BridgeUrl: 'https://stargate.finance/bridge',
    live: false,
    display: true
  }
];
